import { render, staticRenderFns } from "./approveRecord.vue?vue&type=template&id=0de6f637&scoped=true&"
import script from "./approveRecord.vue?vue&type=script&lang=js&"
export * from "./approveRecord.vue?vue&type=script&lang=js&"
import style0 from "./approveRecord.vue?vue&type=style&index=0&id=0de6f637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de6f637",
  null
  
)

export default component.exports